export default {
  user (state) {
    return state.user
  },
  chooseUser (state) {
    return state.chooseUser
  }
}
